import type { ReactElement } from 'react';

import type { IDividerProps } from './divider.interface';

export const Divider = ({
  twColor = 'co-border-gray-xlight'
}: IDividerProps): ReactElement => {
  return <hr className={`co-border-b-1 co-border-t-0 ${twColor}`} />;
};
